(function () {
    'use strict';

    angular
        .module('app.warehouses')
        .controller('WarehousesDetailController', DetailController);

    DetailController.$inject = ['$location', '$stateParams', '$http', 'WarehousesService', 'localStorageService', 'Settings'];

    function DetailController($location, $stateParams, $http, Service, localStorageService, Settings) {
        /* jshint validthis:true */
        var vm = this;

        vm.Settings = Settings;

        Service.get($stateParams.WarehouseId).then(function (data) {
            vm.entity = data;
        });

        vm.fields = Service.getFields();

        vm.delete = function () {
            if (confirm("Silmek istediğinize emin misiniz?")) {
                Service.del(vm.entity).then(function (data) {
                    $location.path('/warehouses/list');
                });
            }
        };
    }
})();
